module.exports = require("favicons-webpack-plugin-ex");